import type { OrderHeaderModel } from '@onrunning/backstage-models';
import { useSessionStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

export const useSelectedOrdersStore = defineStore('selected-grid-orders', () => {
  const selectedOrders = useSessionStorage<Array<OrderHeaderModel>>('selectedOrders', []);

  // getters

  function getSelectedOrders() {
    return selectedOrders.value;
  }

  function addSelectedOrders(newSelectedOrders: OrderHeaderModel[]) {
    selectedOrders.value = newSelectedOrders;
  }

  function removeSelectedOrders() {
    selectedOrders.value = [];
  }

  function $reset() {
    selectedOrders.value = [];
  }

  return {
    addSelectedOrders,
    getSelectedOrders,
    removeSelectedOrders,
    $reset,
  };
});
